export default {
    'name': '55',
    'width': '32',
    'height': '32',
    'viewBox': '0 0 32 32',
    'data': '<g clip-path=\'url(#clip0_193_4780)\'><path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M32 0H0V32H32V0ZM7 19.9667V10.3152L15.3364 5.5V15.1515L7 19.9667ZM16.2273 26.5001L7.84851 21.6849L16.1849 16.8698L24.5424 21.6849L16.2273 26.5001ZM25.3697 10.3152L17.0333 5.5V15.1515L25.3697 19.9667V10.3152Z\' fill=\'white\'/></g><defs><clipPath id=\'clip0_193_4780\'><rect width=\'32\' height=\'32\' fill=\'white\'/></clipPath></defs>'
}
